import { CustomerHistoryDto } from "@modules/finances/gateway/customerHistoryDto"
import { TransactionStatus } from "@modules/finances/types/financesType"

export class CustomerHistoryEntity {
  transactionId: string
  name: string | null
  amount: number
  currency: string
  date: Date
  status: TransactionStatus

  private constructor(customerHistory: CustomerHistoryEntity) {
    this.transactionId = customerHistory.transactionId
    this.name = customerHistory.name
    this.amount = customerHistory.amount
    this.currency = customerHistory.currency
    this.date = customerHistory.date
    this.status = customerHistory.status
  }

  static fromDto(customerHistoryDto: CustomerHistoryDto): CustomerHistoryEntity {
    return new CustomerHistoryEntity({
      transactionId: customerHistoryDto.transactionId,
      name: customerHistoryDto.name,
      amount: customerHistoryDto.amount,
      currency: customerHistoryDto.currency,
      date: new Date(customerHistoryDto.date),
      status: customerHistoryDto.status,
    })
  }
}
